import { officialServerClient } from '@/clientInstance';
import type { IGetThemeListArgs, IGetThemeListResponse } from '../../../../interface/ICommon';

// 获取主题活动列表
export const getActivityThemeList = async ({ country, lang, page }: IGetThemeListArgs):
Promise<IGetThemeListResponse> => {
    const result = await officialServerClient.get<IGetThemeListResponse>(`/common/activity/theme/list?lang=${lang}&country=${country}&page=${page}`);
    return result;
};
